export default __webpack_public_path__ + "static/media/single-project-page-03-img01.8db3c692.jpg";